export const getGclid = (formId) => {
  
    const gclidRecord = JSON.parse(localStorage.getItem('gclid'));
    const gclidField = document.getElementById(`${formId}_gclid_field`);
    if (gclidRecord && new Date().getTime() < gclidRecord.expiryDate && gclidField) {
      gclidField.value = gclidRecord.value;
    }
  };
  